import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const getOtpService = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `communication-provider/otp-service`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}